import { formatDate, formatDateTime } from '../../../tools/format'
import TooltipWrapper from './TooltipWrapper'

interface DateDisplayProps {
    value?: Date | string
    inlineTime?: boolean
    className?: string
    target: string
}

export default function DateDisplay({
    value,
    inlineTime = false,
    className,
    target,
}: DateDisplayProps) {
    const tooltipLabel = formatDateTime(value)
    const inlineLabel = inlineTime ? tooltipLabel : formatDate(value)

    return (
        <TooltipWrapper
            disabled={!value}
            label={tooltipLabel}
            target={`date-display-${target}`}
            position="bottom"
        >
            <span className={className}>{inlineLabel}</span>
        </TooltipWrapper>
    )
}
